<template>
  <div>
    <v-lp-tool-bar/>
    <v-img
      :src="mainImage"
      gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.7)"
    >
      <v-container
        class="main--text"
      >
        <v-row
          justify=center
          align=center
        >
          <v-col
            cols=12
            md=12
          >
            <h3
              class="white--text"
            >ゲームと一緒にプログラミング学習</h3>
            <br>
            <h1
              :class="headingStyle"
            >
              マインクラフトをプレイしながら<br>実践的なプログラミングを学べる
            </h1>
          </v-col>
          <v-col
            cols=6
            sm=6
            md=4
          >
            <v-img
              :src="laurelWreath"
              :contain="true"
            >
              <p class="white--text" v-bind:class="laurelWreathStyle">MicroSoft社開発</p>
            </v-img>
          </v-col>
          <v-col
            cols=6
            sm=6
            md=4
          >
            <v-img
              :src="laurelWreath"
              :contain="true"
            >
              <p class="white--text" v-bind:class="laurelWreathStyle">1億7600万ユーザーの実績</p>
            </v-img>
          </v-col>
          <v-col
            cols=6
            sm=6
            md=4
          >
            <v-img
              :src="laurelWreath"
              :contain="true"
            >
              <p class="white--text" v-bind:class="laurelWreathStyle">教育現場における確かな実績</p>
            </v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-img>

    <VToContactBar/>

    <v-container>
      <v-row
        justify=center
        align=center
      >
        <v-col cols=12>
          <h3 class="text-center font-weight-black">オンラインで学ぶマインクラフトプログラミング</h3>
        </v-col>
      </v-row>
      <v-row
        justify=center
        align=center
      >
        <v-col cols=12>
          <h1 class="text-center font-weight-black display-2">Prosense MineCraft</h1>
        </v-col>
      </v-row>
      <v-row
        justify=center
        align=center
      >
        <v-col cols=12>
          <p class="text-center font-weight-regular">オンラインでマインクラフトを使ったプログラミングが学べる，”Prosense MineCraft”へようこそ！</p>
          <p class="text-center font-weight-bold"><span class="yellow-underline">当サービスではマインクラフトを使いながら楽しくプログラミングを学ぶマンツーマンレッスンを提供しております。</span></p>
          <p class="text-center font-weight-regular">勉強が嫌いなお子さんでもゲームをやりながらプログラミングが出来るので、無理なく続けることができます。</p>
          <p class="text-center font-weight-regular">『Python』による実践的なプログラミングを身につければ<span class="font-weight-bold yellow-underline">将来就職に役立ったり、自分で好きなゲームを開発することができます。</span></p>
        </v-col>
      </v-row>
      <v-row
        justify=center
        align=center
      >
        <iframe width="560" height="315" src="https://www.youtube.com/embed/bYlwddfeIe0?loop=1&playlist=bYlwddfeIe0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </v-row>
    </v-container>

    <VToContactBar/>

    <VSectionBar
      id="target"
      message="こんなお子さんにオススメ"
    />
    <v-container>
      <v-row
        justify=center
      >
        <v-col
          cols=12
          md=8
        >
          <v-card>
            <v-container
              fluid
            >
              <v-row
                justify=center
                align=center>
                <v-col
                  cols=auto>
                  <v-icon
                    size=100
                    color=blue>fa-laptop-code</v-icon>
                </v-col>
                <v-col
                  cols=12
                  md=9>
                  <v-container
                    class="no--vertical--paddings">
                    <v-row
                      justify=center
                      justify-md=start>
                      <v-col
                        cols=auto
                        md=12
                        class="no--vertical--paddings">
                        <h3>本格的プログラミングスキルを身につけたい</h3>
                      </v-col>
                      <v-col
                        cols=12>
                        <span class="yellow-underline font-weight-bold">マインクラフトのプログラミングで使うプログラミングは世界一の人気を誇るプログラミング言語『Python』です。</span>実際に開発現場でも用いられているプログラミング言語を学びます。最初は難しいかもしれませんが、つまづきポイントは担当講師がしっかりとキャッチアップします。
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row
                justify=center
                align=center>
                <v-col
                  cols=auto>
                  <v-icon
                    size=100
                    color=blue>videogame_asset</v-icon>
                </v-col>
                <v-col
                  cols=12
                  md=9>
                  <v-container
                    class="no--vertical--paddings">
                    <v-row
                      justify=center
                      justify-md=start>
                      <v-col
                        cols=auto
                        md=12
                        class="no--vertical--paddings">
                        <h3>ゲーム・マインクラフトが大好き</h3>
                      </v-col>
                      <v-col
                        cols=12>
                        <span class="yellow-underline font-weight-bold">勉強や宿題は全然集中力が続かないけど、マインクラフトやゲームなら何時間でもプレイし続けられるというお子様に最適</span>です。ゲームをプレイしながらプログラミングが身につきます。
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row
                justify=center
                align=center>
                <v-col
                  cols=auto>
                  <v-icon
                    size=100
                    color=blue>fa-chalkboard-teacher</v-icon>
                </v-col>
                <v-col
                  cols=12
                  md=9>
                  <v-container
                    class="no--vertical--paddings">
                    <v-row
                      justify=center
                      justify-md=start>
                      <v-col
                        cols=auto
                        md=12
                        class="no--vertical--paddings">
                        <h3>聞くだけの集団授業が苦手</h3>
                      </v-col>
                      <v-col
                        cols=12
                      >
                        <span class="yellow-underline font-weight-bold">１対１の個別授業形式なので、集団授業で話を聞いてるだけだと集中できないというお子さんでも大丈夫</span>です。ゲームをプレイしてアウトプットしながら講師と一緒に勉強を進められます。  
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <VUsersVoice/>

    <VToContactBar/>

    <VTeachersProfile/>

    <VToContactBar/>

    <VTrialLesson/>

    <VToContactBar/>

    <VLineBenefit/>

    <VToContactBar/>

    <VFreeTrial/>

    <VToContactBar/>

    <VFaq/>

    <VToContactBar/>

    <v-lp-footer/>
  </div>
</template>

<script>
import ChildrenExcitedImage from '@/assets/img/children_excited.jpg'
import VLpToolBar from '@/components/organisms/lp/VLpToolBar.vue'
import VLpFooter from '@/components/organisms/lp/VLpFooter.vue'
import MainImage from '@/assets/img/minecraft/minecraft-main.jpg'
import VToContactBar from '@/components/organisms/portal/VToContactBar.vue'
import LaurelWreath from '@/assets/img/gekkeikan.png'
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VFreeTrial from '@/components/organisms/lp/VFreeTrial.vue'
import VLineBenefit from '@/components/organisms/lp/VLineBenefit.vue'
import VTrialLesson from '@/components/organisms/lp/VTrialLesson.vue'
import VTeachersProfile from '@/components/organisms/lp/VTeachersProfile.vue'
import VFaq from '@/components/organisms/lp/minecraft/VFaq.vue'
import VUsersVoice from '@/components/organisms/lp/minecraft/VUsersVoice.vue'
import { ScrollPositionAnalyticsMixin } from '@/mixins/AnalyticsMixin.js'

import { app } from '@/core/firebase'

export default {
  components: {
    VLpToolBar,
    VLpFooter,
    VToContactBar,
    VSectionBar,
    VFreeTrial,
    VLineBenefit,
    VTrialLesson,
    VTeachersProfile,
    VFaq,
    VUsersVoice
  },
  mixins: [ScrollPositionAnalyticsMixin(app, window)],
  data: () => {
    return {
      mainImage: MainImage,
      laurelWreath: LaurelWreath
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    laurelWreathStyle() {
      return {
        "innter-laurel-wreath-mobile": this.isMobile,
        "inner-laurel-wreath": !this.isMobile
      }
    },
    headingStyle () {
      return (this.isMobile) ? 'heading-text-mobile' : 'heading-text'
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.yellow-underline {
  background: linear-gradient(transparent 60%, #ffff66 60%);
}

.heading-text {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size: 4.5rem;
  letter-spacing: 2px;
}

.innter-laurel-wreath-mobile {
  font-size: 0.7rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}

.inner-laurel-wreath {
  font-size: 1.3rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}

.heading-text-mobile {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size: 2.5rem;
  letter-spacing: 3px;
}

.no--vertical--paddings {
  padding: 0px 12px;
}

.trouble--list li {
  margin: 0px 0px 10px 10px;
  font-weight: bold;
  font-size: 1.4rem;
  color: brown
}

.emphasis--phrase {
  background: linear-gradient(transparent 60%, #ffff66 60%)
}
</style>

